import React from 'react';
import { FadeIn } from './FadeIn';
import { Quote } from 'lucide-react';
export function TestimonialFeatured() {
  return <FadeIn delay={0.2} data-id="element-414">
      <section className="py-12 px-4 max-w-4xl mx-auto pt-[0px] pb-[0px]" data-id="element-415">
        <div className="bg-[#faf7f2] border border-[#e7dfce] rounded-2xl p-8 md:p-12 text-center relative overflow-hidden pt-[0px] pb-[0px] shadow-sm" data-id="element-416">
          <Quote className="absolute top-4 left-4 md:top-8 md:left-8 text-[#f5efe4] w-16 h-16 md:w-24 md:h-24 -z-10 rotate-180" data-id="element-417" />

          <p className="text-xl md:text-3xl font-medium text-[#1f1b16] leading-relaxed mb-6 italic relative z-10" data-id="element-418">
            "La primera noche que usé el protocolo del Tomo 2 dormí 7 horas
            seguidas. Hacía 3 años que no dormía más de 4 sin despertarme. No lo
            podía creer."
          </p>

          <div className="flex items-center justify-center gap-3" data-id="element-419">
            <div className="w-10 h-10 bg-[#7c3aed] rounded-full flex items-center justify-center text-white font-bold text-lg shadow-md" data-id="element-420">
              V
            </div>
            <div className="text-left" data-id="element-421">
              <p className="font-bold text-[#1f1b16]" data-id="element-422">Valeria M.</p>
              <p className="text-sm text-[#6b6358] font-medium" data-id="element-423">
                Docente · La Plata
              </p>
            </div>
          </div>
        </div>
      </section>
    </FadeIn>;
}